import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import useApproveAction from 'components/tables/data/revision/actions/hooks/use-approve-action';
import useConfirmAction from 'components/tables/data/revision/actions/hooks/use-confirm-action';
import { noop } from 'lodash';
import { Menu, Tooltip } from '@mantine/core';
import { IconRubberStamp } from '@tabler/icons-react';
import { useConfirm } from 'components/modals/message/MessageProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who has the permission to approve and accept the revision.
 */
export default function ApproveAndConfirmAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { approveRevision } = useApproveAction();
  const { confirmRevision } = useConfirmAction();
  const { confirm } = useConfirm();

  /**
   * Confirms the approval and confirmation of the revision.
   */
  const confirmApproveAndConfirmRevision = () =>
    confirm({
      title:
        revision.kind === 'revision' ? 'Schválenie a prebratie revíznej správy' : 'Schválenie a prebratie formulára',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete schváliť a prebrať túto revíznu správu?'
          : 'Naozaj si prajete schváliť a prebrať tento formulár?',
      onConfirm: async () => {
        await approveRevision({ revision, onStatusChange });
        await confirmRevision({ revision, onStatusChange });
      },
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Schváliť a prebrať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={confirmApproveAndConfirmRevision}>
          <IconRubberStamp stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={confirmApproveAndConfirmRevision}
        leftIcon={<IconRubberStamp stroke={1.5} size={24} />}
        variant="primary"
        w={188}
      >
        Schváliť a prebrať
      </Button>
    );
  }

  return (
    <Menu.Item
      color="gray.8"
      onClick={confirmApproveAndConfirmRevision}
      icon={<IconRubberStamp stroke={1.5} size={24} />}
    >
      Schváliť a prebrať
    </Menu.Item>
  );
}
